<template>
    <div class="cancel-export-overlay">
      <confirm-dialog
        class="cancel-export-overlay__confirm-dialog"
        message="Are you sure you want to stop the export process?"
        confirmText="Yes"
        cancelText="Cancel"
        @confirm="emits('confirm')"
        @cancel="emits('cancel')"
      />
    </div>
</template>
<script setup lang="ts">
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'
const emits = defineEmits<{
  (event: 'confirm'): void,
  (event: 'cancel'): void,
}>()
</script>

<style lang="scss">
  .cancel-export-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($black, 0.45);
    z-index: 3;

    &__confirm-dialog {
      z-index: 4;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
    }
  }
</style>
